exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-55017f04]{height:20rem}label.cms-label[data-v-55017f04]{color:#223b55;font-size:12px;letter-spacing:.5px;margin-bottom:5px;padding:0}.cms-form-field input[data-v-55017f04]{margin-top:0;font-size:17px}.cms-form-field .cms-field-hint[data-v-55017f04]{font-size:13px;color:#787e84;margin-top:5px}.char-remaining[data-v-55017f04]{text-transform:uppercase;font-size:12px}.char-remaining.good[data-v-55017f04]{color:#90b388}.char-remaining.caution[data-v-55017f04]{color:#dbb823}.char-remaining.warning[data-v-55017f04]{color:#a22020}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55017f04","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/TextArea.vue
// module id = xT+A
// module chunks = 0 1